import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Services
import { ProfileService } from '../../services/profile.service';
import { TfaManageService } from '../../services/tfamanage.service';
import { DataSharingService } from '../../services/data-sharing.service';
import { ProjectService } from '../../services/projects.service';
import { FilterService } from '../../services/filters.service';
import { GeometryService } from '../../services/geometries.service';
import { UploadImportedService } from '../../services/imported.service';
import { PermissionJWTService } from '../../services/permission_jwt.service';
import { MapSideBarService } from '../../pages/project/map/map-sidebar/map-sidebar.service';
import { MapToolBarService } from '../../pages/map-toolbar/map-toolbar.service';
import { MapService } from '../../services/map.service';
import { OperationManagementService } from '../../pages/project/map/map-sidebar/operations/operation_management/operation-management.service';

// Guards
import { AuthGuard } from '../../guards/auth/auth.guard';
import { AdminGuard } from '../../guards/admin/admin.guard';
import { MasterGuard } from '../../guards/master/master.guard';
import { CommonGuard } from '../../guards/common/user.guard';

// Interceptors
import { LoadingInterceptor } from '../../interceptors/loading.interceptor';

// Keycloak
import { 
  AutoRefreshTokenService, 
  UserActivityService, 
  createInterceptorCondition, 
  includeBearerTokenInterceptor, 
  provideKeycloak, 
  withAutoRefreshToken,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG // Adicione isso aqui
} from 'keycloak-angular';import { environment } from '../../../environments/environment';
import { NatService } from '../../services/nat.service';
import { ImportWizardComponent } from '../../pages/project/map/repository/import-wizard/import-wizard.component';
import { IMPORT_WIZARD_COMPONENT_TOKEN } from '../../pages/project/map/repository/import-wizard/import-wizard.storage';
import { FILE_SOURCES, FileSourceTab } from '../../shared/file-source/file-source';
import { ForestCloudService } from '../../pages/project/map/repository/forest-cloud/forest-cloud.service';
import { ForestCloudSourceComponent } from '../../pages/project/map/repository/forest-cloud/forest-cloud-source.component';
import { ImportWizardResolver } from 'src/app/resolvers/shared-import-wizard/shared-import-wizard.resolver';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    // Services
    ProfileService,
    TfaManageService,
    DataSharingService,
    ProjectService,
    FilterService,
    GeometryService,
    UploadImportedService,
    PermissionJWTService,
    MapSideBarService,
    MapToolBarService,
    OperationManagementService,
    MapService,
    NatService,

    // Guards
    AuthGuard,
    AdminGuard,
    MasterGuard,
    CommonGuard,

    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

    // RESOLVERS
    ImportWizardResolver,


    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: IMPORT_WIZARD_COMPONENT_TOKEN,
      useValue: ImportWizardComponent
    },
    // Fontes de arquivo do Import Wizard (entrega 2026-039): a aba só aparece
    // quando GET /api/sources lista a fonte para a pessoa (papel forestcloud_user).
    {
      provide: FILE_SOURCES,
      multi: true,
      deps: [ForestCloudService],
      useFactory: (svc: ForestCloudService): FileSourceTab => ({
        type: 'forestcloud',
        label: 'ForestCloud',
        component: ForestCloudSourceComponent,
        canUse: () => svc.sourceAvailable('forestcloud'),
      }),
    },

    // 1. CONFIGURAÇÃO DO INTERCEPTOR DE TOKEN
    // É aqui que o includeBearerTokenInterceptor vai buscar as regras de URL
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [
        createInterceptorCondition({
          urlPattern: new RegExp('^' + environment.api.url),
          bearerPrefix: 'Bearer'
        }),
        createInterceptorCondition({
          urlPattern: new RegExp('^' + environment.api.eyeforestURL),
          bearerPrefix: 'Bearer'
        })
      ]
    },

    // 2. CONFIGURAÇÃO DO HTTP CLIENT
    provideHttpClient(
      withInterceptors([
        includeBearerTokenInterceptor
      ]),
      withInterceptorsFromDi()
    ),

    // 3. CONFIGURAÇÃO DO KEYCLOAK
    provideKeycloak({
      config: {
        url: environment.KEYCLOAK_URL,
        realm: 'eyeforest',
        clientId: 'app-home'
      },
      initOptions: {
        pkceMethod: 'S256',
        onLoad: 'check-sso',
        scope: 'openid profile email',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html'
      },
      features: [
        withAutoRefreshToken()
      ],
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
  ],
  exports: [
    MatProgressSpinnerModule
  ]
})
export class CoreModule { }
